/**
 * 期限卡 PERIOD 流水行展示语义（period-pass-entitlement，O-14）。
 *
 * PERIOD 事件行（开卡/激活/调整/使用）池变动恒 0、不参与两池守恒：
 * 账本三组数量「前 → 后」列以「—」呈现，可用课时列代之以本函数生成的语义摘要。
 * 口径镜像原型 `prototype/shared/src/utils/labels.ts` + period-pass-parent-ui /
 * parent-ledger-ui 的共享派生函数，三端文案保持一致，禁止页面自行翻译。
 */

/** 摘要输入：PERIOD 流水行的最小字段集（契约字段驱动，不重复算区间）。 */
export interface PeriodLedgerSummaryInput {
  type: string;
  /** 该行期限天数快照（开卡行必携；其余行可空） */
  periodDays?: number | null;
  /** 该行回指的期限卡凭证 ID */
  periodPassId?: string | null;
}

/** 课时类别列的 PERIOD 行文案（区别于正式课/赠送课）。 */
export const PERIOD_LESSON_KIND_LABEL = '期限卡事件（不扣课时）';

/**
 * PERIOD 流水行语义摘要（ADM-24 可用课时列与流水详情「期限卡事件」单项共用）：
 * 开卡「开卡 · 期限 N 天（待激活，不扣课时）」/ 激活「起算区间（不扣课时）」/
 * 调整「调整开始日期，到期日随动重算」/ 使用「期限卡内使用（不扣课时）」。
 */
export function periodLedgerSummary(entry: PeriodLedgerSummaryInput): string {
  switch (entry.type) {
    case 'PURCHASE':
      return `开卡 · 期限 ${entry.periodDays ?? '-'} 天（待激活，不扣课时）`;
    case 'ACTIVATE':
      return '起算区间（不扣课时）';
    case 'ADJUST':
      return '调整开始日期，到期日随动重算';
    case 'USAGE':
      return '期限卡内使用（不扣课时）';
    default:
      return PERIOD_LESSON_KIND_LABEL;
  }
}

/** 期限卡展示状态中文标签（含派生态已到期）。 */
export const periodPassDisplayStatusLabel: Record<string, string> = {
  PENDING_ACTIVATION: '待激活',
  ACTIVE: '生效中',
  EXPIRED: '已到期',
};

/** 期限卡卡片状态徽标颜色（生效中绿 / 待激活金 / 已到期灰）。 */
export function periodPassStatusColor(displayStatus: string): string {
  if (displayStatus === 'ACTIVE') return 'green';
  if (displayStatus === 'EXPIRED') return 'default';
  return 'gold';
}
